// Meoks: hover/touchstart ile dahili linkleri prefetch et — sayfa gecisleri instant
(function () {
  if (!('connection' in navigator) || !navigator.connection.saveData === false) { /* respect save-data */ }
  if (navigator.connection && navigator.connection.saveData) return;
  if (navigator.connection && /2g/.test(navigator.connection.effectiveType || '')) return;

  var done = Object.create(null);
  var TIMEOUT = 80;

  function sameOrigin(href) {
    try { return new URL(href, location.href).origin === location.origin; } catch (e) { return false; }
  }
  function eligible(a) {
    if (!a || !a.href) return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (!sameOrigin(a.href)) return false;
    var u = new URL(a.href);
    if (u.pathname.startsWith('/cart') || u.pathname.startsWith('/checkout') || u.pathname.startsWith('/account')) return false;
    if (u.pathname.match(/\.(jpg|jpeg|png|webp|gif|svg|pdf|zip)$/i)) return false;
    return true;
  }
  function prefetch(href) {
    if (done[href]) return;
    done[href] = 1;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = href;
    document.head.appendChild(l);
  }

  var hoverTimer;
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !eligible(a)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(a.href); }, TIMEOUT);
  }, { passive: true });
  document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && eligible(a)) prefetch(a.href);
  }, { passive: true });

  // viewport'a girenleri idle'da prefetch et (top 8 kart)
  if ('IntersectionObserver' in window && 'requestIdleCallback' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var a = en.target;
        io.unobserve(a);
        if (!eligible(a)) return;
        requestIdleCallback(function () { prefetch(a.href); }, { timeout: 2000 });
      });
    }, { rootMargin: '200px' });
    function seedTop() {
      var links = document.querySelectorAll('.product-grid a[href^="/products/"]');
      for (var i = 0; i < Math.min(links.length, 8); i++) io.observe(links[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', seedTop); else seedTop();
  }
})();
